<cz-numeric-display
  [num]="displayedAmount"
  [zeros]="trailingZeros"
  [class.truncate]="ellipsis && trailingZeros?.length === 0"
></cz-numeric-display>
